var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_vm._t("default",function(){return [(_vm.label)?_c('span',{staticClass:"p-avatar-text"},[_vm._v(_vm._s(_vm.label))]):(_vm.icon)?_c('span',{class:_vm.iconClass}):(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acb66ff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/avatar/Avatar.vue
// module id = R/gf
// module chunks = 38